export enum SocialType {
  Linkedin,
  Twitter,
  Facebook,
  GitHub
}
